import Vue from 'vue';
import toastr from "toastr/toastr";

toastr.options = {
	positionClass: "toast-bottom-left",
	closeButton: true
};

toastr.tr = function() {
	return toastr.success(Vue.prototype.$formatMessage.apply(null, arguments));
};

toastr.cancel = function(message, promiseMaker) {
	message = [
		message,
		"<button type='button' class='btn btn-link'>",
		Vue.prototype.$formatMessage("undo"),
		"</button>"
	].join('');
	var $toast = toastr.success(message, null, {timeOut: 0, extendedTimeOut: 0, tapToDismiss: false});

	var hide = () => {
		toastr.clear($toast)
	};
	var hideTimeout = setTimeout(hide, 6000);

	$toast.find('button.btn').click(function(e) {
		$(this).prop('disabled', true);
		clearTimeout(hideTimeout);

		promiseMaker().then(hide, hide);

		return false;
	});

	return $toast;
};

export default toastr;


// WEBPACK FOOTER //
// ./src/ui/toast.js